<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="All stations" name="first"></el-tab-pane>
			<el-tab-pane label="Create new station" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>Search stations by name or ID</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-70 md-size-20">
					<md-field>
						<label>Status</label>
						<md-select placeholder="Status (All)" v-model="search.status">
							<md-option value="">All</md-option>
							<md-option value="1">Active</md-option>
							<md-option value="0">Inactive</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-30 md-size-20">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">Search</md-button>
				</div>
			</div>
			<md-table v-if="stationList.length > 0">
				<md-table-row>
					<md-table-head>N<sup>o</sup></md-table-head>
					<md-table-head>Station</md-table-head>
					<md-table-head>Location</md-table-head>
					<md-table-head>Total Sensors</md-table-head>
					<md-table-head>Status</md-table-head>
					<md-table-head>Created Date</md-table-head>
					<md-table-head>Action</md-table-head>
				</md-table-row>

				<md-table-row v-for="(station, index) in stationList">
					<md-table-cell>​{{ index + 1 }}</b></md-table-cell>
					<md-table-cell><b>{{ station.hash }}</b><br>{{station.name}}</md-table-cell>
					<md-table-cell><b>Lat: </b>{{station.lat}}<br><b>Lng: </b>{{station.lng}}</md-table-cell>
					<md-table-cell>
						<span v-if="station.total_sensor == null"><b>0 sensor</b></span>
						<span v-else><b>{{ station.total_sensor }} sensor(s)</b></span>
					</md-table-cell>
					<md-table-cell>
						<span class="late" v-if="station.status == 0">{{config.getStatus(station.status)}}</span>
						<span class="green" v-if="station.status == 1">{{config.getStatus(station.status)}}</span>
					</md-table-cell>
					<md-table-cell><b>{{ config.datelify(station.created_date) }}</b><br>{{ config.timelify(station.created_date) }}</md-table-cell>
					<md-table-cell>
						<!-- <router-link :to="'/stations/detail/' + station.hash">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">View more detail</md-tooltip>
							</md-button>
						</router-link> -->
						<router-link :to="'/stations/edit/' + station.hash">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">Edit station detail</md-tooltip>
							</md-button>
						</router-link>
						<template>
							<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(station.id)">
								<md-icon>delete</md-icon>
								<md-tooltip md-direction="top">Delete this station</md-tooltip>
							</md-button>
						</template>
					</md-table-cell>

				</md-table-row>
			</md-table>
			<h4 class="text-center" v-if="stationList.length == 0 && loadMore == true">No stations available</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">Show More</md-button>
			</div>
		</div>

		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Station Information</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* required</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Station Name *</label>
								<md-input type="text" v-model="station.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Station Description *</label>
								<md-input type="text" v-model="station.description"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<label>Station Location *</label>
							<Map :latitude="12.734744" :longitude="104.177401" style="height: 300px"
								@locationUpdated="locationUpdated">
							</Map>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Summary</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">Station Name</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(station.name).length > 0">{{station.name}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Station Description</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(station.description).length > 0">{{station.description}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Station Latitude</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="station.lat != 0">{{station.lat}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Station Longtiude</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="station.lng != 0">{{station.lng}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="createStation()">Create</md-button>
				</div>
			</div>

		</div>


		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this station ?"
			md-content="This station be will be deleted and can't be recovered" md-confirm-text="Delete"
			md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="onDelete" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	import Map from 'vue-google-maps-location-selector';
	export default {
		components: { Datetime, Map },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					status: ""
				},
				station: {
					name: "",
					description: "",
					lat: 0,
					lng: 0
				},
				loadMore: false,
				stationList: []
			}
		},
		methods: {
			locationUpdated(latLng) {
				this.station.lat = latLng.lat;
    			this.station.lng = latLng.lng;
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/station/search", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.stationList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.stationList = more ? this.stationList.concat(data.body.data) : data.body.data;
				})

			},

			searchClient() {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					gender: ""
				}).then(data => {
					this.search.text = "";
					// this.loadMoreCompanyButton = true
					this.search.clientList = data.body.data;
				})
			},
			createStation() {
				if(this.checkValidation()) {
					this.$http.post(this.config.api + "/admin/station/post", {
						station: this.station
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "The station was created successfully.",
								icon: 'done',
								type: 'success'
							})
							this.searchHandler();
							this.tabName = "first";
							this.onCancel();
						}
					})
				}
			},
			removeClient() {

				this.loan.client_id = "";
				this.loan.client = [];
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/station/delete", {
					id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "Station was deleted successfully.",
							icon: 'done',
							type: 'success'
						})
						// this.getEndLicense();
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false,
				this.station = {name: "", description: "", lat: 0, lng: 0}
			},
			checkValidation() {
				if (String(this.station.name).length > 0 && String(this.station.description).length > 0 && this.station.lat != 0 && this.station.lng != 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "Please fill in information.",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.search.text = "";
				this.referral = {
					name: "",
					phone: "",
					description: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Stations/View.vue